export const promoAndMatchdayBoost = {
	10132: {
		categoryId: 10132,
		categoryName: 'Promocje',
		level: 2,
		parentCategory: 10132,
		parentName: 'Promocje',
		sportId: 18,
		sportName: 'Zakłady specjalne',
	},
	10133: {
		categoryId: 10133,
		categoryName: 'MATCHDAY Boost',
		level: 3,
		parentCategory: 10132,
		parentName: 'Promocje',
		sportId: 18,
		sportName: 'Zakłady specjalne',
	},
};
